/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import Container from '@brands/Components/Container/Container';
import { config } from '@brands/config/config';
import careCoordination from '@brands/Dashboard/Dashboard/Patient/components/careCoordinationCase.svg';
import oneReport from '@brands/Dashboard/Dashboard/Patient/components/oneReport.svg';
import clinicalEnablement from '@brands/Dashboard/Dashboard/Patient/components/clinicalEnablement.png';
import oralHealthCoachingCase from '@brands/Dashboard/Dashboard/Patient/components/oralHealthCoachingCase.svg';
import PatientERSection from '@brands/Dashboard/Dashboard/Patient/components/PatientERSection';
import phone from '@brands/Dashboard/Dashboard/Patient/components/phoneIcon.svg';
import secondOpinion from '@brands/Dashboard/Dashboard/Patient/components/secondOpinionCase.svg';
import SmilsScan from '@brands/Dashboard/Dashboard/Patient/components/SmileScan.svg';
import VideoCall from '@brands/Dashboard/Dashboard/Patient/components/VideoCall.svg';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { IListCases, listAllCases } from '@brands/services/cases/listAllCases';
import { notifySelectedCase } from '@brands/services/cases/selectedCase';
import { completeMobileHandoff } from '@brands/services/communication/completeMobileHandover';
import { getBrowserLocationState } from '@brands/services/geolocation/getBrowserLocationState';
import {
  hasSyncedPatientLocationThisSession,
  markPatientLocationSynced,
} from '@brands/services/geolocation/patientLocationSession';
import { getCurrentOrganization } from '@brands/services/identity/getCurrentOrganization';
import { getPricings, Pricings } from '@brands/services/identity/getPricings';
import { getUserAvatar } from '@brands/services/identity/getUserAvatar';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectIsFromHandOff } from '@brands/store/selectors/isFromHandOff';
import { selectShowStateModal } from '@brands/store/selectors/location';
import { setPatientState } from '@brands/store/slices/currentPatientState';
import { setDependents } from '@brands/store/slices/dependentsSlice';
import { resetIsAdminLoginNewDesign } from '@brands/store/slices/isAdminNewDesignSlice';
import { setIsFromHandoff } from '@brands/store/slices/isFromHandOffSlice';
import { setShowStateModal } from '@brands/store/slices/location';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { setOrganization } from '@brands/store/slices/organizationSlice';
import { clearPageState } from '@brands/store/slices/pageStateSlice';
import {
  FormValues,
  resetForm,
  resetIsFromSmileScanReport,
  setForm,
  setSelectedPatient,
} from '@brands/store/slices/patientFormSlice';
import { setSelectedPatientByAdmin } from '@brands/store/slices/selectedPatientSlice';
import { displayErrorDetails } from '@brands/Utils/displayError';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Button } from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { isMobile as mobileDetect } from 'react-device-detect';

import SelectInput from '../../../Components/Inputs/SelectInput/SelectInput';
import { Loading } from '../../../Components/LoadingSpinner/Loading';
import { useOrganizationFlags } from '../../../hooks';
import useCases from '../../../hooks/useCases';
import { useAppDispatch, useAppSelector } from '../../../hooks/useReduxHook';
import useWindowSize from '../../../hooks/useWindowSize';
import { CaseType, ICase } from '../../../services/cases/types/ICase';
import { listDependents } from '../../../services/identity/listDependents';
import { selectBorderLessCustomStyles } from '../../../Utils/customStyles';
import { DEFAULT_PATIENT_LOCATION_STATE, getCurrentPState, setCurrentPatientState } from '../../../Utils/localStorage';
import { stateOptionsWithoutAbbreviation } from '../../../Utils/selectOptions';
import EditCreditCardModal from '../../Appointments/Patient/EditCreditCardModal/EditCreditCardModal';
import OpenCaseListModal from '../Components/OpenCaseListModal/OpenCaseListModal';
import StateModal from '../DashboardModals/StateModal/StateModal';
import PatientEducation from './components/PatientEducation';
import PriceBlock from './components/PriceBlock';
import UpcomingServices from './components/UpcomingServices';
import CareJourneyStrip from '@brands/Dashboard/MyCare/Sections/CareJourneyStrip';
import {
  collapseJourneyCases,
  isOpenJourney,
  useActionNeededJourneyCases,
  useCaseJourneyLookup,
  withActionNeededFirst,
} from '@brands/Dashboard/MyCare/Sections/useCaseJourneyLookup';
import styles from './styles.module.scss';
import { bestCents, priceFor, priceLabelFor, toDollars2 } from './utils/helpers';

const Dashboard = (): JSX.Element => {
  const screenSize = useWindowSize();
  const roleNavigate = useRoleNavigate();
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector(selectAuth);
  const showStateModal = useAppSelector(selectShowStateModal);

  const [selectedCase, setSelectedCase] = useState({
    selectedCaseType: '',
    selectedCasePrice: '',
  });

  const [editCreditCardModal, setEditCreditCardModal] = useState(false);
  const [selectedCaseFromUpcomingServices, setSelectedCaseFromUpcomingServices] = useState<ICase>();
  const [pricingList, setPricingList] = useState<Pricings[]>([]);
  const [numberTypeOfCases, setNumberTypeOfCases] = useState(0);
  const [loading, setLoading] = useState(false);
  const [displayingCases, setDisplayingCases] = useState<ICase[]>([]);
  const currentState = useAppSelector(selectCurrentPatientState) as Record<number, string>;
  const isFromHandoffMobile = useAppSelector(selectIsFromHandOff);
  const isMobile = screenSize.width < 768;
  // What we actually know about the patient's location: detected this session,
  // or their stored selection. Empty means we genuinely don't know, which is
  // what decides whether to prompt — keep it separate from the display value
  // below, or the fallback would read as a resolved location and the
  // confirm-location modal would never open.
  const getStoredPatientLocationState = (): string => currentState[userInfo.id] || getCurrentPState(userInfo.id) || '';
  // What the selector shows. Falls back to NY when nothing is known so the
  // control always displays a state, matching the confirm-location modal.
  const getSelectedPatientLocationState = (): string =>
    getStoredPatientLocationState() || DEFAULT_PATIENT_LOCATION_STATE;
  const [state, setState] = useState<string>(() => getSelectedPatientLocationState());

  const [openCases, setOpenCases] = useState<ICase[]>([]);
  const [openCasesModal, toggleOpenCasesModal] = useState<string | null>(null);

  const targetRef = useRef<HTMLDivElement>(null);

  const params = useMemo(
    () => ({
      sort_by: 'created_at' as const,
      sort_direction: 'desc' as const,
      patient_id: Number(userInfo.id),
      include_vc_stats: true,
      type: [
        CaseType.one_report,
        CaseType.second_opinion,
        CaseType.video_call_scheduled,
        CaseType.phone_call_scheduled,
        CaseType.care_coordination,
        CaseType.oral_health_coaching,
        CaseType.clinical_enablement,
      ],
      status: [
        'new',
        'accepted_care_advisor',
        'accepted_provider',
        'in_progress_provider',
        'in_progress_care_advisor',
        'completed_by_provider',
      ],
      // Dependents' standalone cases belong here too; their program cases are
      // dropped once the list arrives (see the displayingCases effect).
      include_dependents_cases: true,
    }),
    [userInfo.id],
  );

  // The dashboard only shows the account holder's own journeys — a dependent's
  // care journey belongs on the My Care page, not here.
  const journeyPatientIds = useMemo(() => [Number(userInfo.id)], [userInfo.id]);
  const caseJourneys = useCaseJourneyLookup(journeyPatientIds, config.features.multiStage);
  const actionNeeded = useActionNeededJourneyCases(caseJourneys);

  // UpcomingServices only renders the first three cases on the dashboard, so
  // anchoring has to be decided against the same subset — an anchor on a case
  // that is never rendered would lose the strip entirely.
  const visibleCases = useMemo(() => displayingCases.slice(0, 3), [displayingCases]);

  // The strip hangs off the journey's first visible case, which is its
  // action-needed card when there is one (those are listed first). Journeys
  // that haven't ended belong on the dashboard, running or paused; complete and
  // canceled ones surface under Care History instead.
  const journeyAnchors = useMemo(() => {
    const anchors = new Map<number, number>();
    visibleCases.forEach((caseItem) => {
      const match = caseJourneys.byCase.get(Number(caseItem.id));
      if (match && isOpenJourney(match.journey.status) && !anchors.has(match.journey.case_journey_id)) {
        anchors.set(match.journey.case_journey_id, Number(caseItem.id));
      }
    });
    return anchors;
  }, [visibleCases, caseJourneys]);

  // The appointment query filters by case type, so a journey can have no card
  // to hang off (a Clinical Enablement journey has none at all). Those keep the
  // standalone strip so the journey is still reachable.
  const unanchoredJourneys = useMemo(
    () =>
      caseJourneys.journeys.filter(
        (m) => isOpenJourney(m.journey.status) && !journeyAnchors.has(m.journey.case_journey_id),
      ),
    [caseJourneys, journeyAnchors],
  );

  const renderCaseJourneyFooter = (caseItem: ICase): React.ReactNode => {
    const match = caseJourneys.byCase.get(Number(caseItem.id));
    if (!match || journeyAnchors.get(match.journey.case_journey_id) !== Number(caseItem.id)) return null;
    return (
      <CareJourneyStrip
        attached
        patientId={match.patientId}
        journeyId={match.journey.case_journey_id}
        status={match.journey.status}
      />
    );
  };

  const { videoCaseEnabled, asyncCaseEnabled, secondOpinionCaseEnabled } = useOrganizationFlags(state);
  const { cases, dataLoading, reloadAll } = useCases(params, true, userInfo.role.name);

  const resetPatientIntakeForm = (): void => {
    dispatch(resetForm());
    localStorage.setItem('selectedPatientId', '');
    dispatch(setIsFromHandoff(false));
    dispatch(resetIsAdminLoginNewDesign());
    dispatch(resetIsFromSmileScanReport());
  };

  const getOpenCases = async (): Promise<IListCases> => {
    const openCaseParams = {
      sort_by: 'created_at' as const,
      sort_direction: 'desc' as const,
      patient_id: Number(userInfo.id),
      status: [
        'new',
        'accepted_care_advisor',
        'accepted_provider',
        'in_progress_provider',
        'in_progress_care_advisor',
        'completed_by_provider',
      ],
      type: [
        CaseType.one_report,
        CaseType.second_opinion,
        CaseType.video_call_scheduled,
        CaseType.phone_call_scheduled,
        CaseType.care_coordination,
        CaseType.clinical_enablement,
      ],
      limit: 100,
      include_dependents_cases: true,
    };

    const queryStr = Object.entries(openCaseParams)
      .map(([key, value]) => (Array.isArray(value) ? value.map((v) => `${key}=${v}`).join('&') : `${key}=${value}`))
      .join('&');

    const openCaseList = await listAllCases(queryStr);

    openCaseList.nodes = openCaseList.nodes.filter(
      (current) =>
        !(
          (current.type === 'video_call_scheduled' || current.type === 'phone_call_scheduled') &&
          (current.status === 'in_progress_provider' || current.status === 'in_progress_care_advisor')
        ),
    );

    return openCaseList;
  };

  const startPatientForm = async (getCases = true): Promise<void> => {
    if (getCases) {
      await notifySelectedCase('video_call_scheduled');

      const { nodes: openCaseList } = await getOpenCases();
      if (openCaseList?.length > 0) {
        setOpenCases(openCaseList as ICase[]);
        toggleOpenCasesModal('video_call_scheduled');
        return;
      }
    }
    const formPayload: FormValues[] = [
      {
        form_question_id: 20,
        value: {
          caseType: 'video_call_scheduled',
        },
      },
    ];

    dispatch(setForm(formPayload));
    roleNavigate('/select-patient', {
      state: {
        caseType: 'video_call_scheduled',
        currentUserId: userInfo.id,
      },
    });
  };

  const startOneReport = async (getCases = true): Promise<void> => {
    if (getCases) {
      await notifySelectedCase('one_report');

      const { nodes: openCaseList } = await getOpenCases();
      if (openCaseList?.length > 0) {
        setOpenCases(openCaseList as ICase[]);
        toggleOpenCasesModal('one_report');
        return;
      }
    }
    const formPayload: FormValues[] = [
      {
        form_question_id: 20,
        value: {
          caseType: 'one_report',
        },
      },
    ];

    dispatch(setForm(formPayload));
    roleNavigate('/select-patient', { state: { caseType: 'one_report', currentUserId: userInfo.id } });
  };

  const startCareCoordinationCase = async (getCases = true): Promise<void> => {
    if (getCases) {
      await notifySelectedCase('care_coordination');

      const { nodes: openCaseList } = await getOpenCases();
      if (openCaseList?.length > 0) {
        setOpenCases(openCaseList as ICase[]);
        toggleOpenCasesModal(CaseType.care_coordination);
        return;
      }
    }
    const formPayload: FormValues[] = [
      {
        form_question_id: 20,
        value: {
          caseType: CaseType.care_coordination,
        },
      },
    ];

    dispatch(setForm(formPayload));
    roleNavigate('/select-patient', { state: { caseType: CaseType.care_coordination, currentUserId: userInfo.id } });
  };

  const startOralHealthCoachingCase = async (getCases = true): Promise<void> => {
    if (getCases) {
      await notifySelectedCase('oral_health_coaching');

      const { nodes: openCaseList } = await getOpenCases();
      if (openCaseList?.length > 0) {
        setOpenCases(openCaseList as ICase[]);
        toggleOpenCasesModal(CaseType.oral_health_coaching);
        return;
      }
    }
    const formPayload: FormValues[] = [
      {
        form_question_id: 20,
        value: {
          caseType: CaseType.oral_health_coaching,
        },
      },
    ];

    dispatch(setForm(formPayload));
    roleNavigate('/select-patient', { state: { caseType: CaseType.care_coordination, currentUserId: userInfo.id } });
  };

  // /clinical-enablement is the one stable entry URL for this case type; it
  // hands off into the shared patient form (SelectPatient onward) itself, so
  // this card doesn't need to seed form_question_id 20 or pass state here.
  const startClinicalEnablementCase = async (getCases = true): Promise<void> => {
    if (getCases) {
      await notifySelectedCase(CaseType.clinical_enablement);

      const { nodes: openCaseList } = await getOpenCases();
      if (openCaseList?.length > 0) {
        setOpenCases(openCaseList as ICase[]);
        toggleOpenCasesModal(CaseType.clinical_enablement);
        return;
      }
    }
    roleNavigate('/clinical-enablement');
  };

  const startSecondOpinionCase = async (getCases = true): Promise<void> => {
    if (getCases) {
      await notifySelectedCase('second_opinion');

      const { nodes: openCaseList } = await getOpenCases();
      if (openCaseList?.length > 0) {
        setOpenCases(openCaseList as ICase[]);
        toggleOpenCasesModal('second_opinion');
        return;
      }
    }

    const formPayload: FormValues[] = [
      {
        form_question_id: 15,
        value: {
          dental_emergency: 'no',
          sensitive_teeth: 'no',
          second_opinion: 'yes',
          improve_smile: 'no',
          improve_gum_health: 'no',
          grind_teeth_or_snore: 'no',
          something_else: 'no',
        },
      },
      {
        form_question_id: 16,
        value: {
          inPain: 'no',
          pain_description: ['dull'],
          painLevel: 'noPain',
          daysInPain: '',
        },
      },
      {
        form_question_id: 20,
        value: {
          caseType: 'second_opinion',
        },
      },
    ];

    dispatch(setForm(formPayload));
    roleNavigate('/select-patient', { state: { caseType: 'second_opinion', currentUserId: userInfo.id } });
  };

  const getPricingsFn = async (): Promise<void> => {
    setLoading(true);
    try {
      const currentOrganization = await getCurrentOrganization();
      const pricings = await getPricings();
      setPricingList(pricings);
      const count = pricings.filter(
        (item) => item.code !== 'messaging' && item.code !== 'smile_scan' && item.label !== 'Phone Call',
      ).length;

      dispatch(setOrganization({ currentOrganization }));
      setNumberTypeOfCases(count);
      dispatch(setOrganizationPrices({ currentOrganizationPrices: pricings }));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
    setLoading(false);
  };

  const onCloseStateModal = (): void => {
    dispatch(setShowStateModal({ showStateModal: false }));
    setState(getSelectedPatientLocationState());
  };

  useEffect(() => {
    setState(getSelectedPatientLocationState());
  }, [currentState[userInfo.id]]);

  useEffect(() => {
    let mounted = true;

    const syncBrowserLocation = async (): Promise<void> => {
      // Re-detect the browser location once per session, even when a state is
      // already cached, so a returning or redirected patient reflects where
      // they are now instead of being pinned to a previously selected state.
      // The per-session guard keeps in-session refreshes from re-prompting.
      if (hasSyncedPatientLocationThisSession(userInfo.id)) return;

      // Snapshot the stored selection (localStorage is written synchronously by
      // the location selector and modal, so it reflects the patient's latest
      // explicit choice) so we can tell if they change it mid-lookup.
      const storedAtStart = getCurrentPState(userInfo.id);
      const browserLocationState = await getBrowserLocationState();
      if (!mounted) return;

      markPatientLocationSynced(userInfo.id);

      // The patient picked a state while detection was in flight — their
      // explicit choice wins over the detected (and possibly coarse) location.
      if (getCurrentPState(userInfo.id) !== storedAtStart) return;

      if (browserLocationState) {
        // Detection is authoritative for "where the patient is now": apply it
        // over any stale cached selection. The patient can still adjust it from
        // the dashboard's location selector.
        setCurrentPatientState(userInfo.id, browserLocationState);
        dispatch(setPatientState({ userId: userInfo.id, state: browserLocationState }));
        return;
      }

      // Couldn't detect a US location and nothing is stored: don't guess a
      // state into Redux/localStorage as if it were confirmed — just open the
      // modal (it pre-fills a suggested default for display) and let the
      // patient's explicit choice be the first real write.
      if (!getStoredPatientLocationState()) {
        dispatch(setShowStateModal({ showStateModal: true }));
      }
    };

    void syncBrowserLocation();

    return () => {
      mounted = false;
    };
  }, [dispatch, userInfo.id]);

  const completeMobileHandoffFn = async (): Promise<void> => {
    try {
      await completeMobileHandoff();
      dispatch(setIsFromHandoff(false));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  useEffect(() => {
    getPricingsFn();
    resetPatientIntakeForm();
    if ((isMobile || mobileDetect) && isFromHandoffMobile) {
      // Complete Handoff
      completeMobileHandoffFn();
    }
    (async () => {
      if (userInfo.id) {
        dispatch(
          setSelectedPatient({
            value: userInfo.id.toString(),
            label: 'Myself',
          }),
        );
        dispatch(clearPageState());
        dispatch(setSelectedPatientByAdmin({ selectedPatient: userInfo }));
        const listOfDependents = await listDependents(userInfo.id, { include_deleted: true });
        if (listOfDependents.length > 0) {
          dispatch(
            setDependents(
              listOfDependents
                .slice()
                .sort((a, b) => b.id - a.id)
                .map((dependent) => ({
                  value: dependent.id.toString(),
                  label: dependent.full_name,
                  status: dependent.status,
                  image: getUserAvatar(Number(dependent.id)),
                })),
            ),
          );
        }
      }
    })();
  }, []);

  // A dependent's multi-stage program is listed only on My Care, so its cases
  // never reach the dashboard. Dropping them here, before the three visible
  // slots are picked, keeps them from crowding out cards that do belong.
  // case_journey_id comes with the list, so this needs no journey lookup per
  // dependent and the program never flashes up while one loads.
  useEffect(() => {
    if (cases) {
      const listable = cases.filter(
        (caseItem) => caseItem.case_journey_id == null || Number(caseItem.patient_id) === Number(userInfo.id),
      );
      setDisplayingCases(
        withActionNeededFirst(collapseJourneyCases(listable, caseJourneys, params.status), actionNeeded),
      );
    }
  }, [cases, caseJourneys, params.status, userInfo.id, actionNeeded]);

  const renderComingSoon = (): JSX.Element => (
    <div className={`fs-unmask ${styles.comingSoon}`}>We are not currently able to offer this option in your state</div>
  );

  if (loading) {
    return <Loading fullScreen />;
  }

  return (
    <Container
      patientDashboard
      childClassName={styles.dashboard}
      containerStyle={{
        justifyContent: screenSize.width >= 1289 ? 'center' : 'start',
        overflowY: screenSize.width >= 1289 ? 'hidden' : 'scroll',
      }}
    >
      <div className={styles.dashboardContainer}>
        {displayingCases.length > 0 && (
          <UpcomingServices
            displayingCases={displayingCases}
            dataLoading={dataLoading}
            reloadAll={reloadAll}
            setEditCreditCardModal={setEditCreditCardModal}
            selectedCaseFromUpcomingServices={selectedCaseFromUpcomingServices}
            setSelectedCaseFromUpcomingServices={setSelectedCaseFromUpcomingServices}
            isDashboard
            renderCaseFooter={renderCaseJourneyFooter}
            needsIntakeCaseIds={actionNeeded.ids}
          />
        )}
        {config.features.multiStage &&
          unanchoredJourneys.map((match) => (
            <CareJourneyStrip
              key={match.journey.case_journey_id}
              patientId={match.patientId}
              journeyId={match.journey.case_journey_id}
              status={match.journey.status}
              style={{ marginBottom: 12 }}
            />
          ))}
        <div className={styles.dashboardCasesSection}>
          <div className={styles.stateContainer} ref={targetRef}>
            <p className={`${styles.yourStateTitle} fs-unmask`}>Get virtual care from</p>
            <SelectInput
              name="state"
              options={stateOptionsWithoutAbbreviation}
              selectorClass={styles.selector}
              style={selectBorderLessCustomStyles}
              containerClass={`${styles.selectorContainer} fs-mask`}
              selectedValue={state}
              placeholder="Select state"
              onChange={(value) => {
                const selectedState = value?.value;
                if (!selectedState) return;

                setState(selectedState);
                setCurrentPatientState(userInfo.id, selectedState);
                dispatch(setPatientState({ userId: userInfo.id, state: selectedState }));
              }}
            />
          </div>
          <div className={styles.stateContainer} style={{ marginTop: '-15px' }} ref={targetRef}>
            <p className={`fs-unmask ${styles.stateContainerSub}`}>
              We need to know your location during the time of service to match you with a licensed dentist.
            </p>
          </div>
          <div className={styles.cardsContainer}>
            {pricingList.find((price) => price.case_types[0] === CaseType.smile_scan) && (
              <div className={`${styles.dashboardCard} ${styles.first}`}>
                <div className={`${styles.cardWrap} `}>
                  <div className={styles.flexColumn}>
                    <div
                      className={`fs-unmask ${styles.cardHeader}`}
                      style={{ backgroundColor: 'rgb(153, 227, 210, 0.2)' }}
                    >
                      <img src={SmilsScan} />
                    </div>
                    <div className={styles.cardDetaisDiv}>
                      <div className={`fs-unmask ${styles.cardPrice}`}>
                        <span className={styles.priceSpan}>Free</span>
                      </div>
                      <div className={`${styles.cardDetais} ${numberTypeOfCases > 3 ? styles.cardDetaisPadding : ''}`}>
                        <span className={`fs-unmask ${styles.caseName}`}>
                          {priceLabelFor(pricingList, CaseType.smile_scan, 'SmileScan™')}
                        </span>
                      </div>
                      <div className={`${styles.cardDetais}`}>
                        <span className={`fs-unmask ${styles.caseDetails}`}>
                          Share a few quick photos and get a detailed oral health assessment within minutes.
                        </span>
                      </div>
                      <div className={styles.cardFooter} id="main-talk-live-button">
                        <div className={`${styles.rightArrow}`}>
                          <Button
                            onClick={() => {
                              notifySelectedCase('smile_scan');
                              roleNavigate('/smile-scan', {
                                state: {
                                  currentUserId: userInfo.id,
                                },
                              });
                            }}
                            className={`fs-unmask ${styles.dashboardBtn}`}
                            id="smile_scan_get_started"
                            variant="text"
                          >
                            <span>Get started for free</span>
                            <NavigateNextIcon />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {pricingList.find((price) => price.case_types[0] === CaseType.clinical_enablement) && (
              <div className={`${styles.dashboardCard} ${styles.first}`}>
                <div className={`${styles.cardWrap} `}>
                  <div className={styles.flexColumn}>
                    <div className={`fs-unmask ${styles.cardHeader}`} style={{ backgroundColor: 'rgb(240,244,255)' }}>
                      <img src={clinicalEnablement} />
                    </div>
                    <div className={styles.cardDetaisDiv}>
                      <PriceBlock
                        caseType={CaseType.clinical_enablement}
                        casePrice={priceFor(pricingList, CaseType.clinical_enablement)?.amount || 0}
                        hint={(() => {
                          const p = priceFor(pricingList, CaseType.clinical_enablement);
                          const dollars = Number(toDollars2(bestCents(p)));
                          return dollars === 0 ? null : p?.payment_options?.includes('Insurance') ? (
                            <span className={styles.priceHint}>Typically covered by your insurance</span>
                          ) : null;
                        })()}
                      >
                        {(() => {
                          const p = priceFor(pricingList, CaseType.clinical_enablement);
                          const dollars = Number(toDollars2(bestCents(p)));
                          const paymentOptions = p?.payment_options || [];

                          if (dollars === 0) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>Free</span>;
                          }

                          const hasInsurance = paymentOptions.includes('Insurance');
                          const hasSelfPay = paymentOptions.includes('Credit Card');

                          if (hasSelfPay) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars} self pay`}</span>;
                          }
                          if (hasInsurance && !hasSelfPay) {
                            return null;
                          }

                          return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars}`}</span>;
                        })()}
                      </PriceBlock>

                      <div className={`${styles.cardDetais} ${numberTypeOfCases > 3 ? styles.cardDetaisPadding : ''}`}>
                        {/* Clients licence this case type under their own product name
                              (DentKit, sleep apnea, …), so the pricing row's label wins
                              over the default title. */}
                        <span className={`fs-unmask ${styles.caseName}`}>
                          {priceLabelFor(pricingList, CaseType.clinical_enablement, 'Clinical Enablement')}
                        </span>
                      </div>
                      <div className={`${styles.cardDetais}`}>
                        <span className={`fs-unmask ${styles.caseDetails}`}>
                          Submit the required information for your provider to review and determine if you qualify for a
                          recommended dental product or service.
                        </span>
                      </div>
                      <div className={styles.cardFooter} id="main-talk-live-button">
                        <div className={`${styles.rightArrow}`}>
                          {asyncCaseEnabled ? (
                            <Button
                              onClick={() => {
                                const p = priceFor(pricingList, CaseType.clinical_enablement);
                                const dollars = Number(toDollars2(bestCents(p)));
                                setSelectedCase({
                                  selectedCaseType: CaseType.clinical_enablement,
                                  selectedCasePrice: dollars.toString(),
                                });
                                startClinicalEnablementCase();
                              }}
                              className={`fs-unmask ${styles.dashboardBtn}`}
                              id="clinical_enablement_case"
                            >
                              <span>Get started</span>
                              <NavigateNextIcon />
                            </Button>
                          ) : (
                            renderComingSoon()
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {pricingList.find(
              (price) =>
                price.case_types[0] === CaseType.video_call_instant ||
                price.case_types[0] === CaseType.video_call_scheduled,
            ) && (
              <div className={`${styles.dashboardCard} ${styles.first}`}>
                <div className={`${styles.cardWrap} `}>
                  <div className={styles.flexColumn}>
                    <div className={`fs-unmask ${styles.cardHeader}`} style={{ backgroundColor: 'rgb(254,249,241)' }}>
                      <img src={VideoCall} />
                    </div>
                    <div className={styles.cardDetaisDiv}>
                      <PriceBlock
                        caseType={CaseType.video_call_scheduled}
                        casePrice={priceFor(pricingList, CaseType.video_call_scheduled)?.amount || 0}
                        hint={(() => {
                          const p = priceFor(pricingList, CaseType.video_call_scheduled);
                          const dollars = Number(toDollars2(bestCents(p)));
                          return dollars === 0 ? null : p?.payment_options?.includes('Insurance') ? (
                            <span className={styles.priceHint}>Typically covered by your insurance</span>
                          ) : null;
                        })()}
                      >
                        {(() => {
                          const p = priceFor(pricingList, CaseType.video_call_scheduled);
                          const dollars = Number(toDollars2(bestCents(p)));
                          const paymentOptions = p?.payment_options || [];

                          if (dollars === 0) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>Free</span>;
                          }

                          const hasInsurance = paymentOptions.includes('Insurance');
                          const hasSelfPay = paymentOptions.includes('Credit Card');

                          if (hasSelfPay) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars} self pay`}</span>;
                          }
                          if (hasInsurance && !hasSelfPay) {
                            return null;
                          }

                          return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars}`}</span>;
                        })()}
                      </PriceBlock>

                      <div className={`${styles.cardDetais} ${numberTypeOfCases > 3 ? styles.cardDetaisPadding : ''}`}>
                        <span className={`fs-unmask ${styles.caseName}`}>
                          {priceLabelFor(
                            pricingList,
                            [CaseType.video_call_scheduled, CaseType.video_call_instant],
                            'Talk Live with a Dentist',
                          )}
                        </span>
                      </div>
                      <div className={`${styles.cardDetais}`}>
                        <span className={`fs-unmask ${styles.caseDetails}`}>
                          Chat with a dentist over a video call, anytime, anywhere.
                        </span>
                      </div>
                      <div className={styles.cardFooter} id="main-talk-live-button">
                        <div className={`${styles.rightArrow}`}>
                          {videoCaseEnabled ? (
                            <Button
                              onClick={() => {
                                const pInstant = priceFor(pricingList, CaseType.video_call_instant);
                                const pScheduled = priceFor(pricingList, CaseType.video_call_scheduled);
                                const cents = bestCents(pInstant || pScheduled);
                                const dollars = Number(toDollars2(cents));
                                setSelectedCase({
                                  selectedCaseType: CaseType.video_call_scheduled,
                                  selectedCasePrice: dollars.toString(),
                                });
                                startPatientForm();
                              }}
                              className={`fs-unmask ${styles.dashboardBtn}`}
                              id="video_case"
                            >
                              <span>Schedule now</span>
                              <NavigateNextIcon />
                            </Button>
                          ) : (
                            renderComingSoon()
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {pricingList.find((price) => price.case_types[0] === CaseType.one_report) && (
              <div className={`${styles.dashboardCard} ${styles.first}`}>
                <div className={`${styles.cardWrap} `}>
                  <div className={styles.flexColumn}>
                    <div className={`fs-unmask ${styles.cardHeader}`} style={{ backgroundColor: 'rgb(238,252,248)' }}>
                      <img src={oneReport} />
                    </div>
                    <div className={styles.cardDetaisDiv}>
                      <PriceBlock
                        caseType={CaseType.one_report}
                        casePrice={priceFor(pricingList, CaseType.one_report)?.amount || 0}
                        hint={(() => {
                          const p = priceFor(pricingList, CaseType.one_report);
                          const dollars = Number(toDollars2(bestCents(p)));
                          return dollars === 0 ? null : p?.payment_options?.includes('Insurance') ? (
                            <span className={styles.priceHint}>Typically covered by your insurance</span>
                          ) : null;
                        })()}
                      >
                        {(() => {
                          const p = priceFor(pricingList, CaseType.one_report);
                          const dollars = Number(toDollars2(bestCents(p)));
                          const paymentOptions = p?.payment_options || [];

                          if (dollars === 0) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>Free</span>;
                          }

                          const hasInsurance = paymentOptions.includes('Insurance');
                          const hasSelfPay = paymentOptions.includes('Credit Card');

                          if (hasSelfPay) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars} self pay`}</span>;
                          }
                          if (hasInsurance && !hasSelfPay) {
                            return null;
                          }

                          return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars}`}</span>;
                        })()}
                      </PriceBlock>

                      <div className={`${styles.cardDetais} ${numberTypeOfCases > 3 ? styles.cardDetaisPadding : ''}`}>
                        <span className={`fs-unmask ${styles.caseName}`}>
                          {priceLabelFor(pricingList, CaseType.one_report, 'Send Photos for Review')}
                        </span>
                      </div>
                      <div className={`${styles.cardDetais}`}>
                        <span className={`fs-unmask ${styles.caseDetails}`}>
                          Upload photos of your concern for a dentist to review and evaluate.
                        </span>
                      </div>
                      <div className={styles.cardFooter} id="main-talk-live-button">
                        <div className={`${styles.rightArrow}`}>
                          {asyncCaseEnabled ? (
                            <Button
                              onClick={() => {
                                const p = priceFor(pricingList, CaseType.one_report);
                                const dollars = Number(toDollars2(bestCents(p)));
                                setSelectedCase({
                                  selectedCaseType: CaseType.one_report,
                                  selectedCasePrice: dollars.toString(),
                                });
                                startOneReport();
                              }}
                              className={`fs-unmask ${styles.dashboardBtn}`}
                              id="async_case"
                            >
                              <span>Get started</span>
                              <NavigateNextIcon />
                            </Button>
                          ) : (
                            renderComingSoon()
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {pricingList.find((price) => price.case_types[0] === CaseType.second_opinion) && (
              <div className={`${styles.dashboardCard} ${styles.first}`}>
                <div className={`${styles.cardWrap} `}>
                  <div className={styles.flexColumn}>
                    <div className={`fs-unmask ${styles.cardHeader}`} style={{ backgroundColor: 'rgb(249,241,255)' }}>
                      <img src={secondOpinion} />
                    </div>
                    <div className={styles.cardDetaisDiv}>
                      <PriceBlock
                        caseType={CaseType.second_opinion}
                        casePrice={priceFor(pricingList, CaseType.second_opinion)?.amount || 0}
                        hint={(() => {
                          const p = priceFor(pricingList, CaseType.second_opinion);
                          const dollars = Number(toDollars2(bestCents(p)));
                          return dollars === 0 ? null : p?.payment_options?.includes('Insurance') ? (
                            <span className={styles.priceHint}>Typically covered by your insurance</span>
                          ) : null;
                        })()}
                      >
                        {(() => {
                          const p = priceFor(pricingList, CaseType.second_opinion);
                          const dollars = Number(toDollars2(bestCents(p)));
                          const paymentOptions = p?.payment_options || [];

                          if (dollars === 0) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>Free</span>;
                          }

                          const hasInsurance = paymentOptions.includes('Insurance');
                          const hasSelfPay = paymentOptions.includes('Credit Card');

                          if (hasSelfPay) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars} self pay`}</span>;
                          }
                          if (hasInsurance && !hasSelfPay) {
                            return null;
                          }

                          return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars}`}</span>;
                        })()}
                      </PriceBlock>

                      <div className={`${styles.cardDetais} ${numberTypeOfCases > 3 ? styles.cardDetaisPadding : ''}`}>
                        <span className={`fs-unmask ${styles.caseName}`}>
                          {priceLabelFor(pricingList, CaseType.second_opinion, 'Second Opinion')}
                        </span>
                      </div>
                      <div className={`${styles.cardDetais}`}>
                        <span className={`fs-unmask ${styles.caseDetails}`}>
                          Ask questions and get the answers you need to make a confident decision.
                        </span>
                      </div>
                      <div className={styles.cardFooter} id="main-talk-live-button">
                        <div className={`${styles.rightArrow}`}>
                          {secondOpinionCaseEnabled ? (
                            <Button
                              onClick={() => {
                                const p = priceFor(pricingList, CaseType.second_opinion);
                                const dollars = Number(toDollars2(bestCents(p)));
                                setSelectedCase({
                                  selectedCaseType: CaseType.second_opinion,
                                  selectedCasePrice: dollars.toString(),
                                });
                                startSecondOpinionCase();
                              }}
                              className={`fs-unmask ${styles.dashboardBtn}`}
                              id="second_opinion_case"
                            >
                              <span>Get started</span>
                              <NavigateNextIcon />
                            </Button>
                          ) : (
                            renderComingSoon()
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {pricingList.find((price) => price.case_types[0] === CaseType.care_coordination) && (
              <div className={`${styles.dashboardCard} ${styles.first}`}>
                <div className={`${styles.cardWrap} `}>
                  <div className={styles.flexColumn}>
                    <div className={`fs-unmask ${styles.cardHeader}`} style={{ backgroundColor: 'rgb(224,247,250)' }}>
                      <img src={careCoordination} />
                    </div>
                    <div className={styles.cardDetaisDiv}>
                      <PriceBlock
                        caseType={CaseType.care_coordination}
                        casePrice={priceFor(pricingList, CaseType.care_coordination)?.amount || 0}
                        hint={(() => {
                          const p = priceFor(pricingList, CaseType.care_coordination);
                          const dollars = Number(toDollars2(bestCents(p)));
                          return dollars === 0 ? null : p?.payment_options?.includes('Insurance') ? (
                            <span className={styles.priceHint}>Typically covered by your insurance</span>
                          ) : null;
                        })()}
                      >
                        {(() => {
                          const p = priceFor(pricingList, CaseType.care_coordination);
                          const dollars = Number(toDollars2(bestCents(p)));
                          const paymentOptions = p?.payment_options || [];

                          if (dollars === 0) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>Free</span>;
                          }

                          const hasInsurance = paymentOptions.includes('Insurance');
                          const hasSelfPay = paymentOptions.includes('Credit Card');

                          if (hasSelfPay) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars} self pay`}</span>;
                          }
                          if (hasInsurance && !hasSelfPay) {
                            return null;
                          }

                          return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars}`}</span>;
                        })()}
                      </PriceBlock>

                      <div className={`${styles.cardDetais} ${numberTypeOfCases > 3 ? styles.cardDetaisPadding : ''}`}>
                        <span className={`fs-unmask ${styles.caseName}`}>
                          {priceLabelFor(pricingList, CaseType.care_coordination, 'Care Coordination')}
                        </span>
                      </div>
                      <div className={`${styles.cardDetais}`}>
                        <span className={`fs-unmask ${styles.caseDetails}`}>
                          We’ll help you find and book an appointment with a nearby dentist.
                        </span>
                      </div>
                      <div className={styles.cardFooter} id="main-talk-live-button">
                        <div className={`${styles.rightArrow}`}>
                          <Button
                            onClick={() => {
                              const p = priceFor(pricingList, CaseType.care_coordination);
                              const dollars = Number(toDollars2(bestCents(p)));
                              setSelectedCase({
                                selectedCaseType: CaseType.care_coordination,
                                selectedCasePrice: dollars.toString(),
                              });
                              startCareCoordinationCase();
                            }}
                            className={`fs-unmask ${styles.dashboardBtn}`}
                            id="care_coordination_case"
                          >
                            <span>Get started</span>
                            <NavigateNextIcon />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {pricingList.find((price) => price.case_types[0] === CaseType.oral_health_coaching) && (
              <div className={`${styles.dashboardCard} ${styles.first}`}>
                <div className={`${styles.cardWrap} `}>
                  <div className={styles.flexColumn}>
                    <div className={`fs-unmask ${styles.cardHeader}`} style={{ backgroundColor: 'rgb(253,248,225)' }}>
                      <img src={oralHealthCoachingCase} />
                    </div>
                    <div className={styles.cardDetaisDiv}>
                      <PriceBlock
                        caseType={CaseType.oral_health_coaching}
                        casePrice={priceFor(pricingList, CaseType.oral_health_coaching)?.amount || 0}
                        hint={(() => {
                          const p = priceFor(pricingList, CaseType.oral_health_coaching);
                          const dollars = Number(toDollars2(bestCents(p)));
                          return dollars === 0 ? null : p?.payment_options?.includes('Insurance') ? (
                            <span className={styles.priceHint}>Typically covered by your insurance</span>
                          ) : null;
                        })()}
                      >
                        {(() => {
                          const p = priceFor(pricingList, CaseType.oral_health_coaching);
                          const dollars = Number(toDollars2(bestCents(p)));
                          const paymentOptions = p?.payment_options || [];

                          if (dollars === 0) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>Free</span>;
                          }

                          const hasInsurance = paymentOptions.includes('Insurance');
                          const hasSelfPay = paymentOptions.includes('Credit Card');

                          if (hasSelfPay) {
                            return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars} self pay`}</span>;
                          }
                          if (hasInsurance && !hasSelfPay) {
                            return null;
                          }

                          return <span className={`fs-unmask ${styles.priceSpan}`}>{`$${dollars}`}</span>;
                        })()}
                      </PriceBlock>

                      <div className={`${styles.cardDetais} ${numberTypeOfCases > 3 ? styles.cardDetaisPadding : ''}`}>
                        <span className={`fs-unmask ${styles.caseName}`}>
                          {priceLabelFor(pricingList, CaseType.oral_health_coaching, 'Oral Health Coaching')}
                        </span>
                      </div>
                      <div className={`${styles.cardDetais}`}>
                        <span className={`fs-unmask ${styles.caseDetails}`}>
                          Improve your at-home oral care with support from an oral health expert.
                        </span>
                      </div>
                      <div className={styles.cardFooter} id="main-talk-live-button">
                        <div className={`${styles.rightArrow}`}>
                          <Button
                            onClick={() => {
                              const p = priceFor(pricingList, CaseType.oral_health_coaching);
                              const dollars = Number(toDollars2(bestCents(p)));
                              setSelectedCase({
                                selectedCaseType: CaseType.oral_health_coaching,
                                selectedCasePrice: dollars.toString(),
                              });
                              startOralHealthCoachingCase();
                            }}
                            className={`fs-unmask ${styles.dashboardBtn}`}
                            id="oral_health_coaching_case"
                          >
                            <span>Schedule now</span>
                            <NavigateNextIcon />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <PatientEducation />
        <div className={styles.operatingHours}>
          <span className={`fs-unmask ${styles.title}`}>
            <span className={styles.titleHeader}>Request a phone consultation</span>
            <span>
              <img src={phone} alt="phone" />
              {isMobile || mobileDetect ? <a href="tel:844-240-1883">844-240-1883</a> : '844-240-1883'}
            </span>
          </span>
          <span className={`fs-unmask ${styles.operatingHoursSpan}`}>
            <span className={styles.operatingHoursTitle}>Operating hours</span>
            <span className={styles.operatingHoursText}>
              Monday through Friday, 8 am—11 pm ET, with availability on weekends and bank holidays.
            </span>
          </span>
          <span className={`fs-unmask ${styles.operatingHoursFooter}`}>
            If contacted outside of these times, a care team member will follow up as soon as possible during available
            hours.
          </span>
          {pricingList.find((price) => price.case_types[0] === CaseType.smile_scan) && (
            <div className={`fs-unmask ${styles.smileScanNote}`}>
              Connect from any device, no need to download an app
            </div>
          )}
        </div>
        <PatientERSection />
        {editCreditCardModal && (
          <EditCreditCardModal
            setOpenModal={setEditCreditCardModal}
            isOpen={editCreditCardModal}
            thisCase={selectedCaseFromUpcomingServices!}
            reloadAll={reloadAll}
            refreshAll={reloadAll}
          />
        )}
      </div>
      <StateModal isOpen={showStateModal} onClose={onCloseStateModal} />
      <OpenCaseListModal
        isOpen={openCasesModal}
        toggleModal={toggleOpenCasesModal}
        openCases={openCases}
        startOneReport={startOneReport}
        startPatientForm={startPatientForm}
        selectedCase={selectedCase}
        startSecondOpinionCase={startSecondOpinionCase}
        startCareCoordinationCase={startCareCoordinationCase}
        startOralHealthCoachingCase={startOralHealthCoachingCase}
        startClinicalEnablementCase={startClinicalEnablementCase}
      />
    </Container>
  );
};
export default React.memo(Dashboard);
